<template>
  <FormDialog
    :visible="visible"
    :title="dialogTitle"
    :width="480"
    @close="$emit('close')"
  >
    <el-form
      ref="emailForm"
      :model="form"
      :rules="rules"
      label-width="80px"
      label-position="right"
      @submit.native.prevent
    >
      <el-form-item label="邮箱" prop="email">
        <el-input
          v-model="form.email"
          placeholder="请输入收票邮箱"
          maxlength="128"
        />
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button
        class="indiv-btn"
        type="primary"
        size="small"
        :loading="submitting"
        @click="onSubmit"
      >
        提交
      </el-button>
    </template>
  </FormDialog>
</template>

<script>
/** 新增/编辑收票邮箱弹窗 */
import { saveEmail } from './api';

const EMPTY_FORM = {
  id: null,
  email: '',
};

export default {
  name: 'InvoiceEmailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
      form: { ...EMPTY_FORM },
    };
  },
  computed: {
    isEdit() {
      return this.editData && this.editData.id != null;
    },
    dialogTitle() {
      return this.isEdit ? '编辑邮箱' : '添加邮箱';
    },
    rules() {
      return {
        email: [
          { required: true, message: '请输入收票邮箱', trigger: ['blur', 'change'] },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change'] },
        ],
      };
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm();
        return;
      }
      this.fillForm(this.editData);
    },
  },
  methods: {
    fillForm(data) {
      if (data && data.id != null) {
        this.form = {
          id: data.id,
          email: data.email || '',
        };
      } else {
        this.form = { ...EMPTY_FORM };
      }
      this.$nextTick(() => {
        const form = this.$refs.emailForm;
        if (form) form.clearValidate();
      });
    },
    resetForm() {
      this.form = { ...EMPTY_FORM };
      this.submitting = false;
    },
    close() {
      this.$emit('close');
    },
    onSubmit() {
      const form = this.$refs.emailForm;
      if (!form || this.submitting) return;
      form.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        const payload = {
          email: String(this.form.email || '').trim(),
        };
        if (this.isEdit) {
          payload.id = this.form.id;
        }
        saveEmail(payload)
          .then(() => {
            this.$emit('success', { mode: this.isEdit ? 'edit' : 'add' });
            this.close();
          })
          .catch((err) => {
            this.$message.error((err && err.message) || '保存失败');
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/client/personal-center/panels/TitleManage/InvoiceEmailDialog.vue